import React, { useState, useEffect, useContext } from "react"
import axios from 'axios'

import { GlobalContext, HOST } from "./context/GlobalContext"

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Offcanvas from 'react-bootstrap/Offcanvas'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import './App.css'
import { X } from "react-bootstrap-icons"

const LIBRO_PROV_API = HOST + '/api/inv/librosProv/'
const LIBRO_PROV_UPDATE_API = HOST + '/api/inv/librosProv/update'

function LibroProv({ idLibro }) {
  const { setGlobalLoading, setMailBody, setMailTitle, setShowMesage, getNombreProveedor, proveedoresList, token, rol } = useContext(GlobalContext);

  const [ libroProvList, setLibroProvList ] = useState([])

  const [ show, setShow ] = useState(false)
  const [ action, setAction ] = useState('Crear Proveedor')

  const [ idProveedor, setIdProveedor ] = useState()

  useEffect(() => {
    setGlobalLoading( true )
    getLibroProv()
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getLibroProv = () => {
    axios({
      method: 'get',
      url: LIBRO_PROV_API + idLibro,
      headers: { 'Authentication': token }
    })
    .then(result => {
      console.log("libro Prov", result.data)
      setLibroProvList( result.data )
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setGlobalLoading( false )
    })
  }

  const showForm = (item) => {

    if( item ){
      setAction('Actualizar Proveedor del Libro')
      setIdProveedor(item.libroProv.idProveedor)
    } else {
      setAction('Nuevo Proveedor del Libro')
      setIdProveedor(null)
    }

    setShow(true)
  }

  const updateItem = (e) => {
    e.preventDefault();
    setGlobalLoading( true )

    var json = { libroProv: { idLibro: idLibro, idProveedor: idProveedor } }

    console.log('json to update libro proveedor', json)

    axios.post(LIBRO_PROV_UPDATE_API, json, {
			headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result update", result.data)
      getLibroProv()
      setShow(false)
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  return (
    <>
      <Offcanvas show={show} onHide={ () => setShow(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form">{ action }</div>
            <div className="desc-form"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form id="almacenForm" onSubmit={ updateItem }>
            <Container>
              <Row>
                <div>
                  <input type="hidden" name="idLibro" value={ idLibro } />
                  <Container>
                    <Row>
                      <Col md="12">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Proveedores">
                            <Form.Select required name="idProveedor" value={ idProveedor } onChange={ (e) => setIdProveedor( e.target.value ) }>
                              <option>Selecciona una opción</option>
                              { proveedoresList.map( item => (
                                <option key={ item.idProveedor } value={ item.idProveedor }>{ item.razonSocial }</option>
                              ))}
                            </Form.Select>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Container>
                  
                  <br/>
                  <div align="center">
                    <button type="button" className="cancel-btn" onClick={ () => setShow(false) } >{ 'Cancelar' }</button>&nbsp;&nbsp;
                    <button type="submit" className="grl-btn">{ 'Guardar' }</button>
                  </div>
                </div>
              </Row>
            </Container>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      <Container className='main-component'>
        <Row>
          <Col md={ 9 }>
          </Col>
          <Col md={ 3 } align="right">
            { parseInt(rol) === 2 && <div className="single-btn" onClick={ () => showForm() } > Nuevo </div> }
          </Col>
        </Row>
        <Row>
          <Col>
            <Table responsive>
              <thead>
                <tr>
                  <th>Proveedor</th>
                  { parseInt(rol) === 2 && <th></th> }
                </tr>
              </thead>
              <tbody>
                { libroProvList.length === 0 && 
                  <tr>
                    <td colSpan="6"> <div>Sin registros</div> </td>
                  </tr>
                }
                { libroProvList.map( item => (
                  <tr key={ item.libroProv.idProveedor }>
                    <td> 
                      { getNombreProveedor(item.libroProv.idProveedor).razonSocial }
                    </td>
                    { parseInt(rol) === 2 &&
                      <td align="right"> 
                        <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Editar</Tooltip>}>
                          <X onClick={ () => showForm(item) } className="table-icon" />
                        </OverlayTrigger>
                      </td>
                    }
                  </tr>
                )) }
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>

    </>
  );
}

export default LibroProv;
